/**
 * 深色背景用 饼图
 * @param unit 单位
 * @param labelType 可不传默认显示数值，传值选择展示百分比
 * @param dataArr [{name:'',value:0}]数据合集
 */
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let labelType = {
    defData: {
      formatter: function (param) {
        let str = [
          `{c|${dealBigNum(param.value)}${paramObj.unit}}`,
          `{b|${param.name}}`,
        ].join("\n");
        return str;
      },
      rich: {
        c: {
          color: "#FFFFFF",
          fontSize: 16,
          fontWeight: "bold",
          lineHeight: 5,
        },
        b: {
          color: "#A1A7B8",
          fontSize: 12,
          height: 40,
        },
      },
    },
    percentage: {
      formatter: function (param) {
        return (
          "{d|" +
          (param.percent == undefined || param.percent < 0.01
            ? 0.01
            : param.percent) +
          "%}\n" +
          "{b|" +
          param.name +
          "}"
        );
      },
      rich: {
        d: {
          color: "#FFFFFF",
          fontSize: 16,
          fontWeight: "bold",
          lineHeight: 5,
        },
        b: {
          color: "#A1A7B8",
          fontSize: 12,
          height: 40,
        },
      },
    },
  };
  let option = {
    tooltip: {
      trigger: "item",
      formatter: function (param) {
        return `${param.name}:${dealBigNum(param.value)}${paramObj.unit} ${
          param.percent == undefined || param.percent < 0.01
            ? 0.01
            : param.percent
        }%`;
      },
    },
    series: [
      {
        type: "pie",
        radius: "75%",
        center: ["50%", "50%"],
        color: [
          "#16CEC7",
          "#797EED",
          "#51A4F6",
          "#EADEA2",
          "#F3938F",
          "#31E9E5",
          "#6569FF ",
          "#309DF6",
          "#C2D8C2",
          "#048590",
          "#8CA4D7",
          "#8DAC88",
          "#BCB085",
          "#A68CD7",
          "#B49590",
        ],
        data: paramObj.dataArr,
        roseType: "radius",
        label: paramObj.labelType ? labelType.percentage : labelType.defData,
        labelLine: {
          lineStyle: {
            color: "rgb(98,137,169)",
          },
          smooth: 0.2,
          length: 10,
          length2: 20,
        },
        itemStyle: {
          shadowColor: "rgba(0, 0, 0, 0.8)",
          shadowBlur: 50,
        },
      },
    ],
  };

  return option;
}
